import { mediaViewerClicksConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerClicks';
import { mediaViewerCommentsConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerComments';
import { mediaViewerCommentsOnReachConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerCommentsOnReach';
import { mediaViewerEngagementConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerEngagement';
import { mediaViewerEngagementOnImpressionsConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerEngagementOnImpressions';
import { mediaViewerEngagementOnReachConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerEngagementOnReach';
import { mediaViewerEngagementRateConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerEngagementRate';
import { mediaViewerImpressionsConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerImpressions';
import { mediaViewerImpressionsRateConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerImpressionsRate';
import { mediaViewerLikesOnReachConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerLikesOnReach';
import { mediaViewerReachConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerReach';
import { mediaViewerReachRateConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerReachRate';
import { mediaViewerReactionsConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerReactions';
import { mediaViewerSharesConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerShares';
import { mediaViewerSharesOnReachConfig } from '@/lib/analytics/kpis/linkedin/mediaViewer/mediaViewerSharesOnReach';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { LI_POST_TYPES, POST } from '@/lib/posts/postTypes';

const DEFAULT_CONFIG = [
    // Line 1
    { ...mediaViewerEngagementConfig, size: SIZE_FULL },

    // Line 2
    mediaViewerReactionsConfig,
    mediaViewerCommentsConfig,

    // Line 3
    mediaViewerSharesConfig,
    mediaViewerClicksConfig,

    // Line 4
    mediaViewerEngagementRateConfig,
    mediaViewerEngagementOnImpressionsConfig,

    // Line 5
    mediaViewerReachConfig,
    mediaViewerImpressionsConfig,

    // Line 6
    mediaViewerReachRateConfig,
    mediaViewerImpressionsRateConfig,

    // Line 7
    mediaViewerEngagementOnReachConfig,
    mediaViewerLikesOnReachConfig,

    // Line 8
    mediaViewerCommentsOnReachConfig,
    mediaViewerSharesOnReachConfig
];

const VIDEOS_CONFIG = [
    // Line 1
    { ...mediaViewerEngagementConfig, size: SIZE_FULL },

    // Line 2
    mediaViewerReactionsConfig,
    mediaViewerCommentsConfig,

    // Line 3
    mediaViewerSharesConfig,
    mediaViewerClicksConfig,

    // Line 4
    mediaViewerEngagementRateConfig,
    mediaViewerEngagementOnImpressionsConfig,

    // Line 5
    mediaViewerReachConfig,
    mediaViewerImpressionsConfig,

    // Line 6
    mediaViewerReachRateConfig,
    mediaViewerImpressionsRateConfig,

    // Line 7
    mediaViewerEngagementOnReachConfig,
    mediaViewerLikesOnReachConfig,

    // Line 8
    mediaViewerCommentsOnReachConfig,
    mediaViewerSharesOnReachConfig
];

export const MediaViewerStatsLinkedin = {
    [POST]: {
        [LI_POST_TYPES.TYPE_PHOTO]: DEFAULT_CONFIG,
        [LI_POST_TYPES.TYPE_CAROUSEL]: DEFAULT_CONFIG,
        [LI_POST_TYPES.TYPE_STATUS]: DEFAULT_CONFIG,
        [LI_POST_TYPES.TYPE_LINK]: DEFAULT_CONFIG,
        [LI_POST_TYPES.TYPE_DOCUMENT]: DEFAULT_CONFIG,
        [LI_POST_TYPES.TYPE_CAROUSEL]: DEFAULT_CONFIG,
        [LI_POST_TYPES.TYPE_POLL]: DEFAULT_CONFIG,
        [LI_POST_TYPES.TYPE_VIDEO]: VIDEOS_CONFIG
    }
};
